import { gql } from 'react-apollo';

export const resendPastorConfirmation = gql`
  mutation resendPastorConfirmation($input: ResendPastorConfirmationInput!) {
    resendPastorConfirmation(input: $input)
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/churches/mutations/resendPastorConfirmation.js